// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"120":"313b40ed27a6e11e91a3","827":"9cfdac724f16426a1657"}[chunkId] + ".css";
};